import React from 'react'
import  {Grid, TextField, Select, MenuItem, InputLabel,FormControl,} from '@material-ui/core'
import {useSelector} from 'react-redux'
import { isUndefined, isEmpty } from 'lodash'
import IntlMessages from 'util/IntlMessages';

export default function DaysSettings(props) {

  const [typ, setTyp] = React.useState(0)
  const [options, setOptions] = React.useState([])

  const ArandeList = useSelector(state => state.accountsData.ArandeList)


  const handleSelectTyp = (e) => {
    let typeId = parseInt(e.target.value)

    let typeObj = ArandeList.find(al => al.id === typeId)
    if(!isUndefined(typeObj))  {
      // setTyp(typeId)
      // setOptions(typeObj.Operator)
      props.handlePushFilter(JSON.stringify({Meta:'Typ', Value: typeObj.type}))
    }
  }
  const handleSetKategori = (e) => {
    let kategori = e.target.value
    props.handlePushFilter(JSON.stringify({Meta:'Category', Value: kategori}))
  }
  return (
    <>
      <Grid item xs="12">
          <TextField
              variant="outlined"
              fullWidth
              label={<IntlMessages id="input.Erand.Type"/>}
              size="small"
              name="type"
              select
              value={typ}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={handleSelectTyp}
            >
              <option Key="0" selected value={0}><IntlMessages id="Choose"/></option>
          {ArandeList.map((option) => (
            <option key={option.id} value={option.id}>
              {option.type}
            </option>
          ))}
        </TextField>  
      </Grid>
      <Grid item xs="12">
      <TextField
              variant="outlined"
              fullWidth
              label={<IntlMessages id="input.Category"/>}
              size="small"
              name="type"
              select
              value={0}
              SelectProps={{native: true,}}
              InputLabelProps={{shrink: true,}}
              onChange={handleSetKategori}
            >
              <option Key="0" value={0}><IntlMessages id="Choose"/></option>
              {ArandeList.map((option) => option.Operator.map(oo =>(
                <option key={oo.id} value={oo.operator}>
                  {oo.operator}
                </option> 
              )))}
            </TextField>  
      </Grid>
    </>
  )
}
